/* eslint-disable max-len */

export const ImageCaptureIcon = () => {
  return (
    <svg
      width="67"
      height="66"
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Big Shutter / Default">
        <g id="Shutter outline">
          <mask
            id="path-1-outside-1_2268_147820"
            maskUnits="userSpaceOnUse"
            x="0.5"
            y="0"
            width="66"
            height="66"
            fill="black"
          >
            <rect fill="white" x="0.5" width="66" height="66" />
            <path d="M65.5 33C65.5 50.6731 51.1731 65 33.5 65C15.8269 65 1.5 50.6731 1.5 33C1.5 15.3269 15.8269 1 33.5 1C51.1731 1 65.5 15.3269 65.5 33ZM4.03208 33C4.03208 49.2747 17.2253 62.4679 33.5 62.4679C49.7747 62.4679 62.9679 49.2747 62.9679 33C62.9679 16.7253 49.7747 3.53208 33.5 3.53208C17.2253 3.53208 4.03208 16.7253 4.03208 33Z" />
          </mask>
          <path
            d="M65.5 33C65.5 50.6731 51.1731 65 33.5 65C15.8269 65 1.5 50.6731 1.5 33C1.5 15.3269 15.8269 1 33.5 1C51.1731 1 65.5 15.3269 65.5 33ZM4.03208 33C4.03208 49.2747 17.2253 62.4679 33.5 62.4679C49.7747 62.4679 62.9679 49.2747 62.9679 33C62.9679 16.7253 49.7747 3.53208 33.5 3.53208C17.2253 3.53208 4.03208 16.7253 4.03208 33Z"
            fill="white"
          />
          <path
            d="M65.5 33C65.5 50.6731 51.1731 65 33.5 65C15.8269 65 1.5 50.6731 1.5 33C1.5 15.3269 15.8269 1 33.5 1C51.1731 1 65.5 15.3269 65.5 33ZM4.03208 33C4.03208 49.2747 17.2253 62.4679 33.5 62.4679C49.7747 62.4679 62.9679 49.2747 62.9679 33C62.9679 16.7253 49.7747 3.53208 33.5 3.53208C17.2253 3.53208 4.03208 16.7253 4.03208 33Z"
            stroke="white"
            strokeWidth="1.14286"
            mask="url(#path-1-outside-1_2268_147820)"
          />
        </g>
        <circle
          id="Shutter protection"
          cx="33.2588"
          cy="32.7588"
          r="29.4737"
          fill="black"
          fillOpacity="0.55"
        />
        <circle
          id="Center shutter"
          cx="33.0592"
          cy="32.5592"
          r="24.7018"
          fill="white"
        />
      </g>
    </svg>
  );
};
